import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss']
})
export class SuccessDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { message: any, title: string, okText: string},
    private mdDialogRef: MatDialogRef<SuccessDialogComponent>,
    private route: Router)
  {
    mdDialogRef.disableClose = true;
  }

  public close(value: any) {
    this.mdDialogRef.close(value);
  }

  public ok() {
    this.close(true);
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.onSameUrlNavigation = 'reload';
    this.route.navigate(['/file']);
  }

  public getColumnsErrors(arrErrors: any[]) {
    return arrErrors.join(',');
  }


}
